const semanticClassNames = {
  root: 'logo',
} as const;

export default semanticClassNames;
